import { CSSProperties } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { CategoryType } from "../CategorySubheader";

function getIconFilename(icon: CategoryType) {
  switch (icon) {
    case "swas":
      return "SWas.png";
    case "troops":
      return "Troop.png";
    case "terrains":
      return "Terrain.png";
    case "actions":
      return "Action.png";
    case "nations":
      return "Nation.png";
  }
}

const Container = styled(Link)`
  display: block;
  width: calc(80 * var(--u));
  height: calc(80 * var(--u) * 259 / 1512);
  background-size: cover;
  background-repeat: no-repeat;
  text-decoration: none;
`;

const FlexContainer = styled.span`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.span<{ icon: CategoryType }>`
  display: block;
  height: 100%;
  aspect-ratio: 1;
  background: url("/assets/ui/cards/${({ icon }) => getIconFilename(icon)}");
  background-size: contain;
  background-repeat: no-repeat;
`;

const Label = styled.span`
  text-align: center;
  color: black;
  font-size: calc(5 * var(--u));
  margin-top: calc(2 * var(--u));
  margin-left: calc(2 * var(--u));
  font-weight: bold;
`;

export function CategoryButton(props: {
  label: string;
  icon: CategoryType;
  to: string;
  style?: CSSProperties;
}) {
  return (
    <Container to={props.to} style={props.style}>
      <FlexContainer>
        <Icon icon={props.icon} />
        <Label>{props.label}</Label>
      </FlexContainer>
    </Container>
  );
}
